import styled from "styled-components";

const BlocksStyles = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 45px;
  width: 100%;
`;

export { BlocksStyles };
